const zodValidator = () => {
  return {
    validate({ value }, fn) {
      const result = fn.safeParse(value);
      if (!result.success) {
        return result.error.issues.map((issue) => issue.message).join(", ");
      }
      return;
    },
    async validateAsync({ value }, fn) {
      const result = await fn.safeParseAsync(value);
      if (!result.success) {
        return result.error.issues.map((issue) => issue.message).join(", ");
      }
      return;
    }
  };
};
export {
  zodValidator
};
//# sourceMappingURL=validator.js.map
